module.exports = __webpack_public_path__ + "static/img/water6.33609d2f.webp";